import Button from '../atoms/Button'
import OfferCard from '../cards/OfferCard'
import css from './OffersGrid.module.scss'

export default function OffersGrid({ offers, handleMore, count }) {
	return (
		<>
			<div className={css['grid']}>
				{offers.map(offer => {
					return <OfferCard {...offer} key={offer._id} />
				})}
			</div>
			{offers.length < count ? (
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						marginTop: 25,
						marginBottom: 25,
					}}>
					<Button label={'Show More'} action={handleMore} />
				</div>
			) : null}
		</>
	)
}
